import React from 'react'
import RowItem from './OrganizationalUnitTreeView.RowItem'

export const prepareTreeData = (input, actions, localize, language) => {
  const processRows = (maximumLevel, items, currentLevel) => {
    if (items && items.length > 0) {
      return items.map(item => {
        return {
          title: (
            <RowItem
              item={item}
              id={item.id}
              name={item.name}
              latinName={item.latinName}
              canDelete={(item.children || []).length === 0}
              canAdd={currentLevel < maximumLevel}
              actions={actions}
              localize={localize}
              language={language}
              unitType={item.unitType}
            />
          ),
          children: processRows(maximumLevel, item.children, currentLevel + 1),
          expanded: true
        }
      })
    }
    return null
  }

  const data = []

  if (input && input.tree && input.tree.length > 0) {
    const rows = processRows(input.maximumLevel, input.tree, 1)
    if (rows) { rows.forEach(row => data.push(row)) }
  }
  return data
}

export default prepareTreeData

export const processTreeData = (treeData) => {
  const processRows = (items) => {
    if (items && items.length > 0) {
      return items.map(item => {
        return {
          id: item.title.props.id,
          name: item.title.props.name,
          latinName: item.title.props.latinName,
          children: processRows(item.children)
        }
      })
    }
    return null
  }

  return processRows(treeData)
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/organizationalUnits/treeView/OrganizationalUnitTreeView.DataSource.js